import React from 'react';
import { useNotify, useRecordContext, useTranslate } from 'react-admin';
import Button from '@mui/material/Button';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { StatsTooltip } from '../../components/statistics/common';

const CustomLogAsTeacherButton = () => {
    const record = useRecordContext();
    const translate = useTranslate();
    const notify = useNotify();
    const application = '0e274549-7a89-4313-8720-0f4588a51f98';
    const ttl = 60;

    const handleClick = async e => {
        e.stopPropagation();

        const api = `${process.env.REACT_APP_INFRA_API}/aspa/create_auth_token`;
        const token = localStorage.getItem('token');

        try {
            const response = await fetch(api, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_guid: record.id,
                    app_id: application,
                    ttl: ttl,
                }),
            });

            if (response.status >= 400) {
                throw new Error('Bad response from server');
            }

            const data = await response.json();
            const baseUrl = {
                dev: 'https://oppimateriaalit-id-dev.otava.fi/v1/oidc/teacher/login',
                next: 'https://oppimateriaalit-id-next.otava.fi/v1/oidc/teacher/login',
                beta: 'https://oppimateriaalit-id-beta.otava.fi/v1/oidc/teacher/login',
                localhost: 'http://localhost:8086/v1/oidc/teacher/login',
                default:
                    'https://oppimateriaalit-id.otava.fi/v1/oidc/teacher/login',
            };

            const env =
                Object.keys(baseUrl).find(key =>
                    new RegExp(`${key}`).test(window.location.hostname)
                ) || 'default';
            window.open(
                `${baseUrl[env]}?authtoken=${data.token}&hash=${data.hash}`,
                '_blank'
            );
        } catch (e) {
            console.error(e);
            notify(`notifications.MATERIAL_PREVIEW_ERROR`, { type: 'warning' });
        }
    };

/*
{
  "id": "74a10bba-735e-45ad-b6b4-576745b3edfd",
  "guid": "74a10bba-735e-45ad-b6b4-576745b3edfd",
  "crm_guid": "a4989d62-3ab1-493c-b43f-2c0fce1e99e5",
  "username": "anni.jokiranta@edupori.fi",
  "status": 0,
  "public": {
    "validto": "2019-05-31",
    "lastname": "Jokiranta",
    "firstname": "Anni",
    "validfrom": "2019-03-14",
    "profile_locked": true,
    "login_not_allowed": true
  },
  "last_login": "2019-05-21T05:13:13Z",
  "registered": "2019-03-14T07:13:30Z",
  "author": {
    "creator": "6c46d7d7-5ece-4e42-9f68-96d92946e685",
    "created": "2019-03-14T07:13:30Z",
    "modifier": "19cefbec-810d-4354-8861-95b91beb5340",
    "modified": "2025-07-15T03:19:03Z"
  }
 }
*/

    const now = new Date();
    const validFrom = record.public?.validfrom ? new Date(record.public.validfrom) : null;
    const validTo = record.public?.validto ? new Date(record.public.validto) : null;
    
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fi-FI', {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric'
        });
    };
    
    const getDisabledReason = () => {
        if (record.status !== 0) return translate('actions.login_as.user_inactive');
        if (record.public?.profile_locked) return translate('actions.login_as.profile_locked');
        if (record.public?.login_not_allowed) return translate('actions.login_as.login_not_allowed');
        if (validFrom && now < validFrom) return translate('actions.login_as.access_starts_on', { date: formatDate(record.public.validfrom) });
        if (validTo && now > validTo) return translate('actions.login_as.access_expired_on', { date: formatDate(record.public.validto) });
        return null;
    };

    const disabledReason = getDisabledReason();
    const isDisabled = !!disabledReason;

    return (
        <StatsTooltip 
            title={disabledReason || translate('actions.login_as.teacher_tooltip')} 
            followCursor
            placement="top-start"
            componentsProps={{
                tooltip: {
                    sx: {
                        padding: '12px 16px',
                        fontSize: '14px',
                        lineHeight: 1.4,
                    }
                }
            }}
        >
            <span>
                <Button
                    onClick={handleClick}
                    disabled={isDisabled}
                    size="small"
                >
                    <RemoveRedEyeIcon />
                </Button>
            </span>
        </StatsTooltip>
    );
};

export default CustomLogAsTeacherButton;
